import React, { useState } from "react";
import "../../styles/searchbar.css";

const EnSearchBar = ({ onSearch, placeholder = "Enter search keywords." }) => {
  const [searchTerm, setSearchTerm] = useState("");

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    onSearch(value);
  };

  const handleSearchClick = () => {
    onSearch(searchTerm);
  };

  const handleSelectChange = (e) => {
    // 셀렉트 박스 변경 처리 (필요시)
  };

  return (
    <div className="search-container">
      <div className="search-bar">
        <div className="select-container">
          <select onChange={handleSelectChange} className="search-select">
            <option value="title">title+content</option>
            {/* <option value="content">content</option> */}
          </select>
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" className="select-arrow">
            <path d="M7 10l5 5 5-5z" fill="#333" />
          </svg>
        </div>
        <input type="text" value={searchTerm} onChange={handleSearchChange} placeholder={placeholder} className="search-input" />
        <button className="search-button" onClick={handleSearchClick} aria-label="검색">
          <svg xmlns="http://www.w3.org/2000/svg" width="40.123" height="40.123" viewBox="0 0 40.123 40.123">
            <path
              data-name="패스 40"
              d="M8.479 0A8.461 8.461 0 0 0 0 8.479v23.165a8.461 8.461 0 0 0 8.479 8.479h23.165a8.461 8.461 0 0 0 8.479-8.479V8.479A8.461 8.461 0 0 0 31.644 0zm10.78 8.025A11.215 11.215 0 0 1 27.738 26.6l5.725 5.725a.8.8 0 1 1-1.135 1.135L26.6 27.738a11.227 11.227 0 1 1-7.341-19.713zm0 1.6a9.63 9.63 0 1 0 9.63 9.63 9.617 9.617 0 0 0-9.63-9.625z"
              className="search-icon"
            />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default EnSearchBar;
